import React from 'react'
import cn from 'classnames'
import { scrollToContent } from '../helpers'
import './Header.styl'

const Header = ({ children, renderBottom, hero, full, showArrow = true }) => (
  <header
    className={cn(
      'c-header',
      { 'c-header--full': full },
      't-context--dark',
      'bg'
    )}
    style={{ backgroundImage: `url(${hero})` }}
  >
    <div className="c-header__content o-container t-center">{children}</div>
    {showArrow && (
      <svg
        viewBox="0 0 24 24"
        className="c-header__arrow"
        onClick={scrollToContent}
      >
        <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
      </svg>
    )}
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js